<div *ngIf="initialized">
  <div class="card">
    <div>
      <header class="card-header bg-light py-3 px-5">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Score Details</h5>
          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </header>
      <div class="card-body">
        <div class="cs_container">
          <div class="cs_popover-body">
            <div class="cs_grid col-1-2">
              <div class="cs_col">
                <div class="cs_img-container">
                  <img src="../../../../assets/img/assessment/{{getGeneralScoreImage()}}" alt="" />
                  <h1>{{score | number: '1.1-1'}}%</h1>
                </div>
              </div>
              <div class="cs_col">
                <h3>About the Score:</h3>
                <p class="cs_text-justify">
                  The RunDNA Running Score summarizes the overall quality
                  of your running form. A high score represents efficient
                  form with low injury risk, while a lower score
                  identifies the need for corrective exercises.
                </p>
              </div>
            </div>

            <h3>Personalized Feedback:</h3>
            <p class="cs_text-justify">
              {{getGeneralScoreDescription()}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
